export const talentInformationStyle = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginTop: '32px',
  },
  editTalentText: {
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '24px',
  },
  externalLinkButton: {
    padding: 0,
  },
  talentInformation: {
    style: {
      display: 'flex',
      gap: '5px',
    },
  },
  editTalentInformation: {
    sx: {

    },
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
    },
  },
  title: {
    style: {
      fontWeight: '600',
      fontSize: '24px',
      lineHeight: '33px',
    },
  },
  subTitle: {
    style: {
      marginTop: '12px',
    },
  },
} as const;
